<mat-card-header class="layout-row align-items-center gap-10px">
  <fa-icon icon="building" size="3x"></fa-icon>
  <mat-card-title-group class="flex-fill">
    <mat-card-title>
      <h2>{{ officeData.name }}</h2>
    </mat-card-title>
  </mat-card-title-group>
</mat-card-header>

<mat-card-content>
  <div class="layout-row-wrap">
    @if (officeData.externalId) {
      <div class="flex-50 mat-body-strong">
        {{ 'labels.inputs.External Id' | translate }}
      </div>
    }
    @if (officeData.externalId) {
      <div class="flex-50">
        <LOSx-external-identifier externalId="{{ officeData.externalId }}"></LOSx-external-identifier>
      </div>
    }

    <div class="flex-50 mat-body-strong">
      {{ 'labels.inputs.Opened On' | translate }}
    </div>
    <div class="flex-50">
      {{ officeData.openingDate | dateFormat }}
    </div>

    <div class="flex-50 mat-body-strong">
      {{ 'labels.inputs.Number of Staff' | translate }}
    </div>
    <div class="flex-50">
      {{ employeeData ? employeeData.length : '' }}
    </div>
  </div>
</mat-card-content>
